import IntegrationTaskResourceListResultModel from '../../generated/types/model/resource/IntegrationTaskResourceListResultModel';

export default class IntegrationTaskResourceListResultViewModel extends IntegrationTaskResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
